import { render, staticRenderFns } from "./ListAdviser.vue?vue&type=template&id=ad56706e&"
import script from "./ListAdviser.vue?vue&type=script&lang=js&"
export * from "./ListAdviser.vue?vue&type=script&lang=js&"
import style0 from "./ListAdviser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListAdviserItem: require('/app/components/list/ListAdviserItem.vue').default})
